var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ts-pt-6"},[_c('MemberCardIndex')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }